"use client";

import { useSyncExternalStore } from "react";
import { SpeedInsights } from "@vercel/speed-insights/next";

const subscribeNoop = () => () => {};
const getIsTopLevelWindow = () => window.self === window.top;
const getServerSnapshot = () => false;

export function TopLevelSpeedInsights() {
  const isTopLevelWindow = useSyncExternalStore(
    subscribeNoop,
    getIsTopLevelWindow,
    getServerSnapshot,
  );

  return isTopLevelWindow ? <SpeedInsights /> : null;
}
